import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./styles/styles.css"
import { initialize } from "@/auth/authService";

// MSAL must be initialised, and any pending redirect response processed, BEFORE
// the app mounts. Mounting first means components can read authState while it is
// still empty and wrongly conclude the user is signed out, which produces a
// visible flicker back to the sign-in button on every page load.
initialize()
  .catch((err) => {
    // A failure here is a configuration problem (bad tenant/client id, redirect
    // URI mismatch). Log it and still mount, so the app renders an error rather
    // than a blank page.
    console.error("MSAL initialisation failed:", err);
  })
  .finally(() => {
    const app = createApp(App);
    app.use(router);
    app.mount("#app");
  });
